import NotFoundPage from '@/pages/not-found.page';
import Journeys from '@/pages/journeys';
import { AppBundle } from '@/utils/app-bundles';
import { getAppBundleFromUrl } from '@/utils/navigation';
import { createFileRoute, useLocation } from '@tanstack/react-router';
import { DesignStudioRoute } from './-components';

function WorkspaceSplatRoute() {
  const location = useLocation();
  const appBundle = getAppBundleFromUrl(location.pathname);

  switch (appBundle) {
    case AppBundle.Journeys:
      return <Journeys />;
    case AppBundle.DesignStudio:
      return <DesignStudioRoute />;
    case null:
      return <NotFoundPage />;
    default: {
      const _exhaustive: never = appBundle;
      return String(_exhaustive);
    }
  }
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/$')({
  component: WorkspaceSplatRoute,
});
